module.exports = __webpack_public_path__ + "img/preauth-dollar.04fd3029.png";